module.exports = __webpack_public_path__ + "img/about3.627ed803.png";